import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import AnotherUserLoginPopup from '../../../components/MultiAppAuthentication/AnotherUserLoginPopup';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos: { isAnotherUserLogin } } = state;
	return {
		isDisplayed: isAnotherUserLogin,
	};
};

export default connect(mapStateToProps)(AnotherUserLoginPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/AnotherUserLoginPopup/index.tsx